import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe7b8f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "popup" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-0fe7b8f0><div class=\"logo\" data-v-0fe7b8f0><svg viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0fe7b8f0><path d=\"M 20 20 L 80 20 L 50 50 Z\" fill=\"#0b3d52\" data-v-0fe7b8f0></path><path d=\"M 20 80 L 80 80 L 50 50 Z\" fill=\"#5ebcb8\" data-v-0fe7b8f0></path></svg></div><h2 class=\"title\" data-v-0fe7b8f0>YB</h2><div class=\"subtitle\" data-v-0fe7b8f0>Downloading report</div></div><div class=\"progress-container\" data-v-0fe7b8f0><div class=\"progress-bar indeterminate\" data-v-0fe7b8f0><div class=\"progress-fill\" data-v-0fe7b8f0></div></div></div>", 2)
const _hoisted_5 = { class: "fact-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fact-title" }, "Did you know?", -1))

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'YBLoadingPopup',
  props: {
  initialVisible: {
    type: Boolean,
    default: true
  }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const visible = ref(props.initialVisible);
const factFading = ref(false);
const currentFactIndex = ref(0);
const factInterval = ref<number | null>(null);

const facts = [
  "Generating AI report...",
  "First time generation takes approximately 20 seconds. Our engines are fully analyzing.",
  "Agility is not just speed, but the ability to make better decisions under uncertainty.",
  "Companies with high agility scores grow up to 25% faster in dynamic markets.",
  "IT agility plays a key role in how fast organizations can seize new opportunities.",
  "A mismatch between agility and market dynamics makes companies more vulnerable.",
  "Sensing, responding, and learning together define how well a company adapts.",
  "Your brain creates time illusions - that's why waiting feels longer than it actually is.",
  "Focused attention makes time seem to pass more quickly.",
  "AI models optimize thousands of variables simultaneously during report generation."
];

const currentFact = computed(() => facts[currentFactIndex.value]);

const updateFact = () => {
  factFading.value = true;
  
  setTimeout(() => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * facts.length);
    } while (newIndex === currentFactIndex.value && facts.length > 1);
    
    currentFactIndex.value = newIndex;
    factFading.value = false;
  }, 1500);
};

onMounted(() => {
  // Start cycling facts every 5 seconds
  factInterval.value = window.setInterval(updateFact, 5000);
});

onBeforeUnmount(() => {
  if (factInterval.value) {
    clearInterval(factInterval.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "×"),
          _hoisted_3,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: _normalizeClass(["fact-text", { 'fade': factFading.value }])
            }, _toDisplayString(currentFact.value), 3)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})